import React, { useState, useRef, useEffect } from 'react';
import {
	Flex,
	Tooltip,
	Text,
	Button,
	useToast,
	Box,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
} from '@chakra-ui/react';
import { faFile, faPlusSquare, faFolderPlus, faMinusSquare, faFileMedical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import c from '../../constant';
import useMoment from '../../hooks/useMoment';
import DownloadAndViewButton from '../Files/DownloadAndViewButton';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
const MUTATION_CREATE_APPLICANT_NOTE = gql`
	mutation set($id: String!, $companyId: String!, $data: JSON!) {
		createApplicantComplaintNote(id: $id, companyId: $companyId, data: $data)
	}
`;

const MUTATION_REMOVE_APPLICANT_NOTE = gql`
	mutation set($id: String!) {
		removeApplicantComplaintNote(id: $id)
	}
`;

export default function ApplicantNote(props) {
	const { t } = useTranslation();
	const { disabled, id, companyId, existingNote, callback } = props;
	const { paperSolarDateString, paperLunarDateString } = useMoment();
	const toast = useToast();

	const [createNote, { data, loading, error }] = useMutation(MUTATION_CREATE_APPLICANT_NOTE);
	const [removeNote, { data: removeNoteData, loading: removeNoteLoading, error: removeNoteError }] = useMutation(MUTATION_REMOVE_APPLICANT_NOTE);

	const [isOpen, setIsOpen] = useState(false);
	const cancelRef = useRef();
	const onClose = () => setIsOpen(false);

	useEffect(() => {
		if (data?.createApplicantComplaintNote) {
			// console.log('note created successfully:', data?.createApplicantComplaintNote);
			toast({
				title: t('Applicant Note created successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			callback();
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			error.graphQLErrors.map(({ message }, i) =>
				toast({
					title: t(message),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				}),
			);
		}
	}, [error]);

	useEffect(() => {
		if (removeNoteData?.removeApplicantComplaintNote) {
			toast({
				title: t('Applicant Note removed successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			callback();
		}
	}, [removeNoteData]);

	useEffect(() => {
		if (removeNoteError) {
			removeNoteError.graphQLErrors.map(({ message }, i) =>
				toast({
					title: t(message),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				}),
			);
		}
	}, [removeNoteError]);

	async function handleCreateNote() {
		await createNote({
			variables: {
				id,
				companyId,
				data: {
					solarDate: paperSolarDateString(),
					lunarDate: paperLunarDateString(),
				},
			},
		});
	}
	return (
		<>
			<Flex>
				{existingNote ? (
					<Flex className="viewContainer" alignItems="center">
						<DownloadAndViewButton url={existingNote?.url} marginLeft={0} />
						<FontAwesomeIcon
							onClick={() => {
								if (!disabled) {
									setIsOpen(true);
								}
							}}
							className="remove"
							icon={faMinusSquare}
							style={{
								fontSize: 18,
								display: 'none',
								position: 'absolute',
								zIndex: '100',
								marginLeft: 160,
								marginBottom: 30,
								color: 'red',
								backgroundColor: 'white',
								padding: 2,
								cursor: 'pointer',
							}}
						/>
					</Flex>
				) : (
					<Flex maxW={480} borderRadius={c.borderRadius} pr="2" h="37px" cursor="pointer" alignItems="center">
						<Button
							className="hidden-print"
							onClick={() => {
								if (!loading) {
									// console.log('create note button clicked...creating note, please wait a minute...');
									handleCreateNote();
								}
							}}
							// leftIcon={<FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: 18 }} />}
							// rightIcon={<FontAwesomeIcon icon={faFile} style={{ fontSize: 18 }} />}
							colorScheme="blue"
							variant="outline"
							isDisabled={disabled}
						>
							<FontAwesomeIcon icon={faFileMedical} style={{ fontSize: 18 }} />
							{/* {t('Add')}: */}
						</Button>
					</Flex>
				)}
			</Flex>

			<>
				<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
					<AlertDialogOverlay>
						<AlertDialogContent>
							<AlertDialogHeader fontSize="lg" fontWeight="bold">
								{t('Delete applicant note file')}
							</AlertDialogHeader>

							<AlertDialogBody>{t("Are you sure? You can't undo this action afterwards")}</AlertDialogBody>

							<AlertDialogFooter>
								<Button ref={cancelRef} disabled={removeNoteLoading} onClick={onClose}>
									{t('Cancel')}
								</Button>
								<Button
									isLoading={removeNoteLoading}
									colorScheme="red"
									onClick={() => {
										removeNote({ variables: { id } });
									}}
									ml={3}
								>
									{t('Delete')}
								</Button>
							</AlertDialogFooter>
						</AlertDialogContent>
					</AlertDialogOverlay>
				</AlertDialog>
			</>
			{loading && <LoadingOverlay />}
		</>
	);
}
